import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AppService } from '@core/services/app.service';
import { ConsentFormService } from '@shared/services/consent-form.service';
import { LoadingService } from '@shared/services/loading.service';
import { takeWhile, tap } from 'rxjs/operators';
import { BaseComponent } from './shared/components/base.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // providers: [{
  //   provide: MatPaginatorIntl, 
  //   useClass: CustomMatPaginatorIntl
  // }]
})
export class AppComponent extends BaseComponent implements OnInit, OnDestroy {

  pageReady = false;
  
  consentForm = new FormGroup({
    consent: new FormControl(false)
  });

  constructor(private injector: Injector,
              private loadingService: LoadingService,
              private appService: AppService,
              private consentFormService: ConsentFormService) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.consentFormService.bind(this.consentForm);
    this.createAPICache();
    this.loadOdsScripts();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private loadOdsScripts() {
    this.backToTop();
  }

  //ODS Required Scripts
  backToTop() {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement("script");
    script.innerHTML = "";
    script.src = "../../../../../assets/ontario-design-system/scripts/back-to-top.js";
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
  //ODS Required Scripts

  private createAPICache() {
    this.appService.createAPICache().pipe(
      takeWhile(() => this.alive),
      tap(() => this.renderApp())
    ).subscribe();
  }

  private renderApp() {
    this.loadingService.stopLoading();
    this.pageReady = true;
    this.changeDetectorRef.markForCheck();
  }
}
